module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Align-justify-5d5ab37bcf54926697038fcfdd7e21d7.svg";